import React, { useState, useEffect } from 'react';
import './Onboarding.css';

function Onboarding({ onStart, loading = false }) {
  const [currentScreen, setCurrentScreen] = useState(0);

  useEffect(() => {
    try {
      if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('event', 'onboarding_start');
      }
    } catch (e) { /* Firefox iOS may throw from gtag */ }
  }, []);

  const screens = [
    {
      title: 'XF - Personal IP Discovery Tool',
      content: (
        <>
          <p className="text-content mb-2">
            This tool, brought to you by your friends at <a href="https://xf.works" target="_blank" rel="noopener noreferrer">xf.works</a>, will interview you about your background and expertise, then suggest <span className="text-accent">personal AI tools</span> you could build.
          </p>
          <p className="text-content mt-2">
            Based on the Personal IP framework from <a href="https://intentional.tech" target="_blank" rel="noopener noreferrer">Intentional Technology</a>, the people part of AI.
          </p>
          <p className="text-muted mt-3">
            Takes about 5 minutes.
          </p>
        </>
      )
    },
    {
      title: 'XF - Personal IP Discovery Tool',
      content: (
        <>
          <p className="text-content mb-2">
            Let's discover what makes you irreplaceable. We'll explore:
          </p>
          <ul className="text-content onboarding-list">
            <li><span className="text-primary">Your unique expertise</span> - what only you know</li>
            <li><span className="text-primary">Your values & boundaries</span> - what matters to you</li>
            <li><span className="text-primary">Your personal toolkit</span> - tools you could build</li>
          </ul>
          <p className="text-muted mt-3" style={{ fontSize: '13px' }}>
            Your content stays private and is not shared or sold. We may use anonymized insights for research and publications. By continuing, you agree to our <a href="/privacy" target="_blank" rel="noopener noreferrer">privacy policy</a> and <a href="/terms" target="_blank" rel="noopener noreferrer">terms of service</a>. Questions? <a href="mailto:hello@xf.works">hello@xf.works</a>
          </p>
        </>
      )
    }
  ];

  const handleNext = () => {
    if (currentScreen < screens.length - 1) {
      setCurrentScreen(currentScreen + 1);
    } else {
      onStart();
    }
  };

  const handlePrev = () => {
    if (currentScreen > 0) {
      setCurrentScreen(currentScreen - 1);
    }
  };

  const screen = screens[currentScreen];

  return (
    <div className="onboarding-container">
      <div className="terminal-frame onboarding-frame">
        <div className="terminal-titlebar">
          {screen.title}
        </div>
        <div className="terminal-content">
          {screen.content}

          <div className="onboarding-nav mt-4">
            <div className="nav-buttons">
              {currentScreen > 0 && (
                <button
                  className="terminal-button"
                  onClick={handlePrev}
                >
                  [back]
                </button>
              )}

              <button
                className="terminal-button"
                onClick={handleNext}
                disabled={loading}
              >
                {loading ? '[starting…]' : (currentScreen < screens.length - 1 ? '[next]' : '[start]')}
              </button>
            </div>

            <div className="nav-indicator mt-2">
              <span className="text-muted">
                {currentScreen + 1} / {screens.length}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Onboarding;
